import { render, staticRenderFns } from "./ContainerNoEditor.vue?vue&type=template&id=06b72c86&scoped=true&"
import script from "./ContainerNoEditor.vue?vue&type=script&lang=js&"
export * from "./ContainerNoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b72c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b72c86')) {
      api.createRecord('06b72c86', component.options)
    } else {
      api.reload('06b72c86', component.options)
    }
    module.hot.accept("./ContainerNoEditor.vue?vue&type=template&id=06b72c86&scoped=true&", function () {
      api.rerender('06b72c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/ContainerNoEditor.vue"
export default component.exports